import { render, staticRenderFns } from "./hotProducts.vue?vue&type=template&id=95516a78&scoped=true&"
import script from "./hotProducts.vue?vue&type=script&lang=js&"
export * from "./hotProducts.vue?vue&type=script&lang=js&"
import style0 from "./hotProducts.vue?vue&type=style&index=0&id=95516a78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95516a78",
  null
  
)

export default component.exports